// Tooltip — dark pill, readable at small font sizes
export const tooltipStyles = {
  components: {
    Tooltip: {
      baseStyle: {
        bg: 'gray.800',
        color: 'white',
        fontSize: 'xs',
        fontWeight: 'medium',
        px: '10px',
        py: '6px',
        borderRadius: 'lg', // 8px — softer than Chakra default
        boxShadow: 'lg',
        maxW: '280px',
        lineHeight: 'snug',
      },
    },
  },
};
